import { render, staticRenderFns } from "./PlayerAttachmentsSidebar.vue?vue&type=template&id=357542c2&scoped=true&"
import script from "./PlayerAttachmentsSidebar.vue?vue&type=script&lang=js&"
export * from "./PlayerAttachmentsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAttachmentsSidebar.vue?vue&type=style&index=0&id=357542c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357542c2",
  null
  
)

export default component.exports